import { type Validation } from '@vuelidate/core'
import type { InjectionKey } from 'vue'
import { ToastConfig } from '../models/ui/toast'

export type UserInterface = {
  id: string
  title: string
  body: string | undefined
  icon: string
  blocked?: boolean
  verified?: boolean
  fullUser?: {
    firstName: string | undefined
    lastName: string | undefined
    email: string | undefined
  }
}

export const vKey: InjectionKey<Validation<any, any> | undefined> = Symbol('v')
export const formNameKey: InjectionKey<string> = Symbol('formName')
export const isUserLoggedKey: InjectionKey<ComputedRef<boolean>> = Symbol('isUserLogged')

export type McFormSubmit = () => Promise<ToastConfig | void> | ToastConfig | void
